import React from "react";
import { connect } from "react-redux";

const mapStateToProps = state => {
    return {
        pluginPath: state.appSettings.pluginPath
    }
}

const PageLoading = (props) => {
    return <div className="page-loading-placeholder">
        <img className="loading-icon" src={props.pluginPath + "/assets/PlaceholderLogo.png"} />
    </div>;
}

export default connect(mapStateToProps)(PageLoading);